import { render, staticRenderFns } from "./PermissionsMatrix.vue?vue&type=template&id=3757ac26&scoped=true&"
import script from "./PermissionsMatrix.vue?vue&type=script&lang=ts&"
export * from "./PermissionsMatrix.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsMatrix.vue?vue&type=style&index=0&id=3757ac26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3757ac26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VDialog,VIcon})
